<app-loading *ngIf="viewModel.isLoading$ | async" [options]="viewModel.loadingOpts$ | async"> </app-loading>

<app-edit-collection-edit-required-displays
  [modalTitle]="'Reload Selected Displays'"
  [hideDescription]="true"
  [reloadableDisplayIds]="viewModel.reloadableDisplayIds$ | async"
  [primaryActionText]="'Reload'"
  (cancelClicked)="cancel()">
</app-edit-collection-edit-required-displays>
